import { render, staticRenderFns } from "./CameraStream.vue?vue&type=template&id=8eaac160&scoped=true&"
import script from "./CameraStream.vue?vue&type=script&lang=js&"
export * from "./CameraStream.vue?vue&type=script&lang=js&"
import style0 from "./CameraStream.vue?vue&type=style&index=0&id=8eaac160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaac160",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
